import {useTransformStore} from '@/stores'
import {useRepository} from '@/composables'
import {mediator, messenger} from '@communication'

export default class TransformProcedure {
  constructor() {
    this.name = 'transformProcedure'
    this.store = useTransformStore()
  }

  install = () => {
    messenger.subscribe(this.name, 'strategy:data', this.handler)
    messenger.subscribe(this.name, 'transform:history', this.handleHistory)
  }

  uninstall = () => {
    messenger.unsubscribe(this.name)
  }

  handleHistory = event => {
    const history = JSON.parse(event.history)
    if (history.length) {
      history.sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp))
      const filtered = history.map(data => ({
        x: data.x,
        y: data.y,
        ...(data.zoom && {zoom: data.zoom}),
      }))
      const transform = filtered.reduce((acc, val) => Object.assign(acc, val), {
        zoom: 1,
        x: 0,
        y: 0,
      })
      this.store.setTransform(transform)
      console.info('recovered from history', {transform})
    }
  }

  handler = (event, channel) => {
    if (channel === 'strategy:data') {
      const {type} = event
      if (type.startsWith('transform')) {
        switch (type) {
          case 'transform:translate': {
            const {x, y} = event
            this.store.setTranslation({x, y})
            break
          }
          case 'transform:set': {
            const {zoom, x, y} = event
            this.store.setTransform({zoom, x, y}, true)
            break
          }
        }
      }
    }
  }

  send = message => {
    const {sendWsEvent} = useRepository()
    mediator.broadcast(message)
    sendWsEvent(message)
  }
}
